export enum IndificationType {
  IndificationNo = 1,
  Passport = 2
}
